import OwnerNavigationRoutes from '@/components/sidebar/OwnerNavigationRoutes'
import OrgAdminNavigationRoutes from '@/components/sidebar/OrgAdminNavigationRoutes'
import TeamManagerNavigationRoutes from '@/components/sidebar/TeamManagerNavigationRoutes'
import SupportAgentNavigationRoutes from '@/components/sidebar/SupportAgentNavigationRoutes'
import AnalystNavigationRoutes from '@/components/sidebar/AnalystNavigationRoutes'
import AnalystViewerOrgNavigationRoutes from '@/components/sidebar/AnalystViewerOrgNavigationRoutes'
import FinanceNavigationRoutes from '@/components/sidebar/FinanceNavigationRoutes'
import DeveloperNavigationRoutes from '@/components/sidebar/DeveloperNavigationRoutes'
import ClientPortalNavigationRoutes from '@/components/sidebar/ClientPortalNavigationRoutes'
import DriverNavigationRoutes from '@/components/sidebar/DriverNavigationRoutes'
import RecruiterNavigationRoutes from '@/components/sidebar/RecruiterNavigationRoutes'
import NavigationRoutes from '@/components/sidebar/NavigationRoutes'
import OperatorNavigationRoutes from '@/components/sidebar/OperatorNavigationRoutes'

export type UserRole =
  | 'owner'
  | 'org_admin'
  | 'team_manager'
  | 'support_agent'
  | 'analyst'
  | 'analyst_viewer_org'
  | 'finance'
  | 'developer'
  | 'client_portal'
  | 'driver'
  | 'recruiter'
  | 'admin'
  | 'operator'
  | 'manager'

export function getNavigationRoutes(userRole: UserRole) {
  switch (userRole) {
    case 'owner':
      return OwnerNavigationRoutes
    case 'org_admin':
      return OrgAdminNavigationRoutes
    case 'team_manager':
      return TeamManagerNavigationRoutes
    case 'support_agent':
      return SupportAgentNavigationRoutes
    case 'analyst':
      return AnalystNavigationRoutes
    case 'analyst_viewer_org':
      return AnalystViewerOrgNavigationRoutes
    case 'finance':
      return FinanceNavigationRoutes
    case 'developer':
      return DeveloperNavigationRoutes
    case 'client_portal':
      return ClientPortalNavigationRoutes
    case 'driver':
      return DriverNavigationRoutes
    case 'recruiter':
      return RecruiterNavigationRoutes
    case 'admin':
    case 'manager':
      return NavigationRoutes
    case 'operator':
    default:
      return OperatorNavigationRoutes
  }
}

export function getDefaultRoute(userRole: UserRole): string {
  switch (userRole) {
    case 'owner':
    case 'org_admin':
    case 'manager':
      return 'dashboard'
    case 'team_manager':
      return 'teams'
    case 'support_agent':
      return 'analytics'
    case 'analyst':
      return 'analytics'
    case 'analyst_viewer_org':
      return 'performance'
    case 'finance':
      return 'dashboard'
    case 'developer':
      return 'test-auth'
    case 'client_portal':
      return 'dashboard'
    case 'recruiter':
      return 'recruiter-dashboard'
    case 'driver':
      return 'dashboard'
    case 'admin':
      return 'dashboard'
    case 'operator':
    default:
      return 'performance'
  }
}

export function getRoleDisplayName(userRole: UserRole): string {
  switch (userRole) {
    case 'owner':
      return 'Owner'
    case 'org_admin':
      return 'Organization Admin'
    case 'team_manager':
      return 'Team Manager'
    case 'support_agent':
      return 'Support Agent'
    case 'analyst':
      return 'Analyst/Viewer'
    case 'analyst_viewer_org':
      return 'Analyst Viewer Org'
    case 'finance':
      return 'Finance'
    case 'developer':
      return 'Developer (API)'
    case 'client_portal':
      return 'Client/Partner Portal'
    case 'driver':
      return 'Driver/Rider/Contractor'
    case 'recruiter':
      return 'Recruiter'
    case 'admin':
      return 'Admin'
    case 'manager':
      return 'Manager'
    case 'operator':
    default:
      return 'Operator'
  }
}
